import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Contract } from '@classes/contract';
import * as _moment from 'moment';
import { ContractType } from '@classes/contract-type';
const moment = _moment;
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/contract';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getContracts(): Observable<Array<Contract>> {
    return this.http.get<Array<Contract>>(this.basePath);
  }

  getContract(id: string): Observable<Contract> {
    return this.http.get<Contract>(`${this.basePath}/${id}`);
  }

  getContractType(): Observable<Array<ContractType>> {
    return this.http.get<Array<ContractType>>(`${this.basePath}/getContractType`);
  }

  createOrUpdateContract(contract?: Contract): Observable<Contract> {
    if (contract && (typeof contract.dateBegin == "object")) {
      contract.dateBegin = moment(contract?.dateBegin).format('YYYY-MM-DDTHH:mm')
    }
    if (contract && (typeof contract.dateEnd == "object")) {
      contract.dateEnd = moment(contract?.dateEnd).format('YYYY-MM-DDTHH:mm')
    }
    if (contract && (typeof contract.dateStartBilling == "object")) {
      contract.dateStartBilling = moment(contract?.dateStartBilling).format('YYYY-MM-DDTHH:mm')
    }

    if (contract?.id) {
      //update
      const url = `${this.basePath}/${contract?.id}`;
      return this.http.patch<any>(url,
        contract).pipe(map(m => {
          return m
        }));
    } else {
      //create
      return this.http.post<any>(this.basePath,
        contract
      ).pipe(map(m => {
        return m
      }));
    }
  }
  createNewContract(contract?: Contract): Observable<Contract> {
    return this.http.post<any>(`${this.basePath}/createContract`,
      contract
    ).pipe(map(m => {
      return m
    }));
  }

  deleteContract(contractId: string): Observable<any> {
    const baseUrl = this.basePath;
    const url = `${baseUrl}/${contractId}`;
    return this.http.delete(url);
  }
}
